// removed by extract-text-webpack-plugin
module.exports = {"vpCurrentLinkModalFooter":"vpCurrentLinkModalFooter___2f6Qw","vpCurrentLinkLoader":"vpCurrentLinkLoader___2HU_s"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/CurrentLinkModal.module.less
// module id = 3794
// module chunks = 33